import { apiSlice } from './apiSlice';
const INCOMES_URL = '/api/incomes';

export const incomesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getIncomes: builder.query({
      query: ({ keyword, pageNumber }) => ({
        url: INCOMES_URL,
        params: { keyword, pageNumber },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Incomes'],
    }),
    getIncomeDetails: builder.query({
      query: (incomeId) => ({
        url: `${INCOMES_URL}/${incomeId}`,
      }),
      keepUnusedDataFor: 5,
    }),
    createIncome: builder.mutation({
      query: (incomeData) => ({
        url: INCOMES_URL,
        method: 'POST',
        body: incomeData,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Incomes'],
    }),
    updateIncome: builder.mutation({
      query: ({ incomeId, ...data }) => ({
        url: `${INCOMES_URL}/${incomeId}`,
        method: 'PUT',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Incomes'],
    }),
    uploadIncomeImages: builder.mutation({
      query: (formData) => ({
        url: '/api/upload',
        method: 'POST',
        body: formData,
      }),
    }),
      bulkUpdateIncomes: builder.mutation({
  query: (incomeData) => ({
    url: `${INCOMES_URL}/bulk`, // Adjust this if your backend uses a different route
    method: 'PUT',
    body: incomeData,
    headers: {
      'Content-Type': 'application/json',
    },
  }),
  invalidatesTags: ['Incomes'],
}),

    deleteIncome: builder.mutation({
      query: (incomeId) => ({
        url: `${INCOMES_URL}/${incomeId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Incomes'],
    }),
    createReview: builder.mutation({
      query: ({ incomeId, ...data }) => ({
        url: `${INCOMES_URL}/${incomeId}/reviews`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Incomes'],
    }),
    getTopIncomes: builder.query({
      query: () => `${INCOMES_URL}/top`,
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useGetIncomesQuery,
  useGetIncomeDetailsQuery,
  useCreateIncomeMutation,
  useUpdateIncomeMutation,
  useUploadIncomeImagesMutation,
  useDeleteIncomeMutation,
  useCreateReviewMutation,
  useGetTopIncomesQuery,
  useBulkUpdateIncomesMutation,
  
} = incomesApiSlice;